module.exports = __webpack_public_path__ + "img/__icon_PLATFORMA.a0010525.svg";